import type { TraderRepresentative } from "./types";

export const getTraderRepresentativeFullName = (representative?: TraderRepresentative) => {
  const fullName = representative?.person?.full_name;
  if (fullName) {
    return fullName;
  }

  const firstName = representative?.person?.first_name;
  const lastName = representative?.person?.last_name;
  const nameParts = [firstName, lastName].filter(Boolean);

  return nameParts.length ? nameParts.join(" ") : "-";
};
